import React, { ReactElement } from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

import CloseIcon from '@/components/commons/icons/CloseIcon';

interface Props {
    readonly open: boolean;
    readonly onClose: () => void;
    readonly children: ReactElement | Array<ReactElement>;
    // if no headline, won't render a header or the divider
    readonly headline?: string;
    // optional classNames
    readonly classNames?: {
        // className to add to the top level modal
        modal: string;
        // className to add to the close button
        closeButton?: string
    };
    readonly styles?: {
        modalContainer: object;
    };
}

const defaultClassNames = {
    modal: 'modal',
    closeButton: 'modal--closeButton',
};

function StandardModal({
    open,
    onClose,
    children,
    headline = null,
    classNames = defaultClassNames,
    styles = {
        modalContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
        },
    },
}: Props) {
    if (!classNames.closeButton) {
        // eslint-disable-next-line no-param-reassign
        classNames.closeButton = defaultClassNames.closeButton;
    }
    return (
        <Modal
            open={open}
            styles={styles}
            onClose={onClose}
            classNames={classNames}
            center
            closeIcon={<CloseIcon id="close-button" className="h-4 w-4" />}
        >
            <div className="modal--body">
                {headline && ([
                    <h3 key="modal-headline" className="modal--headline" id="modal-headline">
                        {headline}
                    </h3>,
                    <hr key="modal-divider" className="modal--divider" />,
                ])}
                <div>
                    {children}
                </div>
            </div>
        </Modal>
    );
}

export default StandardModal;
